module.exports = __webpack_public_path__ + "img/nct-graphic.255e55f8.png";